"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.renderComponents = exports.renderComponentsWithBridge = exports.storyBlokClickableProps = exports.StoryBlokClickableItem = exports.pushToCustomComponents = exports.customComponents = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// [{ componentName: 'MyCoolComp', Component: MyCoolComp, props: {} }]
var customComponents = [];
exports.customComponents = customComponents;

var pushToCustomComponents = function pushToCustomComponents(components) {
  if (components.length > 0) components.forEach(function (component) {
    return customComponents.push(component);
  });
};

exports.pushToCustomComponents = pushToCustomComponents;

var StoryBlokClickableItem = function StoryBlokClickableItem(props) {
  if (process.env.REACT_APP_ENV !== 'production' && props._editable) {
    var cName = "".concat(props.component.component, " storyblok--outline");

    var escapedJSONData = props._editable.substring(props._editable.lastIndexOf('{'), props._editable.lastIndexOf('}') + 1);

    return /*#__PURE__*/_react.default.createElement("div", {
      className: cName,
      "data-blok-c": escapedJSONData,
      "data-blok-uid": props._uid,
      key: props === null || props === void 0 ? void 0 : props._uid
    }, /*#__PURE__*/(0, _react.createElement)(props.components[props.component.component], props));
  }

  return /*#__PURE__*/(0, _react.createElement)(props.components[props.component.component], _objectSpread({}, props));
};

exports.StoryBlokClickableItem = StoryBlokClickableItem;

var storyBlokClickableProps = function storyBlokClickableProps(_ref) {
  var _editable = _ref._editable,
      component = _ref.component,
      _uid = _ref._uid;

  if (process.env.REACT_APP_ENV !== 'production' && _editable) {
    var storyblokClass = "".concat(component, " storyblok--outline");

    var escapedJSONData = _editable.substring(_editable.lastIndexOf('{'), _editable.lastIndexOf('}') + 1);

    return {
      dataBlokC: escapedJSONData,
      dataBlokUid: _uid,
      storyblokClass: storyblokClass
    };
  }

  return {
    dataBlokC: '',
    dataBlokUid: '',
    storyblokClass: ''
  };
};

exports.storyBlokClickableProps = storyBlokClickableProps;

var renderComponentsWithBridge = function renderComponentsWithBridge(components, component) {
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  var customComponent = customComponents.find(function (comp) {
    return comp.componentName === component.component;
  });

  if (customComponent) {
    return /*#__PURE__*/(0, _react.createElement)(customComponent.Component, _objectSpread({}, Object.assign(customComponent.props, component, {
      key: key
    })));
  }

  return /*#__PURE__*/(0, _react.createElement)(components[component.component], _objectSpread(_objectSpread({}, component), {}, {
    key: key
  }, storyBlokClickableProps(component)));
};

exports.renderComponentsWithBridge = renderComponentsWithBridge;

var renderComponents = function renderComponents(components, component) {
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  var props = _objectSpread(_objectSpread({}, component), {}, {
    key: key
  });

  var customComponent = customComponents.find(function (comp) {
    return comp.componentName === component.component;
  });

  if (customComponent) {
    return /*#__PURE__*/_react.default.createElement(StoryBlokClickableItem, (0, _extends2.default)({}, Object.assign(customComponent.props, component, {
      key: key
    }), {
      components: components,
      component: customComponent.Component
    }));
  }

  if (process.env.REACT_APP_ENV === 'production') {
    return /*#__PURE__*/(0, _react.createElement)(components[component.component], props);
  }

  return /*#__PURE__*/_react.default.createElement(StoryBlokClickableItem, (0, _extends2.default)({}, props, {
    components: components,
    component: component
  }));
};

exports.renderComponents = renderComponents;
var _default = renderComponents;
exports.default = _default;